export const authApiRoutes = {
  guestLogin: '/auth/guest-login',
  saveUser: '/auth/create-guest-user',
};
